import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { createPayrollPeriod } from 'services/payroll.service';

export default function CreatePayrollPeriodModal({ isOpen, onClose, onSuccess }) {
  const currentDate = new Date();
  const [formData, setFormData] = useState({
    month: currentDate.getMonth() + 1,
    year: currentDate.getFullYear(),
    description: '',
  });
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (!formData.month || !formData.year) {
      toast({
        title: 'Error',
        description: 'Complete todos los campos obligatorios',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true);
      
      // Calcular fechas del período
      const month = Number(formData.month);
      const year = Number(formData.year);
      
      // Primer día del mes
      const startDate = new Date(year, month - 1, 1);
      
      // Último día del mes
      const endDate = new Date(year, month, 0);
      
      // Fecha de pago: 5 del mes siguiente
      const paymentDate = new Date(year, month, 5);
      
      // Formatear fechas a YYYY-MM-DD
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const response = await createPayrollPeriod({
        month,
        year,
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        paymentDate: formatDate(paymentDate),
        description: formData.description,
        createdBy: 1, // TODO: Obtener del contexto de usuario
      });
      
      if (response.status === 201) {
        toast({
          title: 'Éxito',
          description: 'Período de liquidación creado correctamente',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onSuccess();
      }
    } catch (error) {
      toast({
        title: 'Error',
        description:
          error.response?.data?.message ||
          'No se pudo crear el período de liquidación',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Crear Período de Liquidación</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Mes</FormLabel>
              <Select
                name="month"
                value={formData.month}
                onChange={handleChange}
              >
                <option value="1">Enero</option>
                <option value="2">Febrero</option>
                <option value="3">Marzo</option>
                <option value="4">Abril</option>
                <option value="5">Mayo</option>
                <option value="6">Junio</option>
                <option value="7">Julio</option>
                <option value="8">Agosto</option>
                <option value="9">Septiembre</option>
                <option value="10">Octubre</option>
                <option value="11">Noviembre</option>
                <option value="12">Diciembre</option>
              </Select>
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Año</FormLabel>
              <Input
                name="year"
                type="number"
                value={formData.year}
                onChange={handleChange}
                min="2020"
                max="2030"
              />
            </FormControl>

            <FormControl>
              <FormLabel>Descripción</FormLabel>
              <Textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Opcional: descripción del período"
                rows={3}
              />
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancelar
          </Button>
          <Button colorScheme="blue" onClick={handleSubmit}>
            Crear Período
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
